var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeyType } from '@interfaces/keys.interface';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import Config from 'src/config';
const send = (json, username, key, keyType, mainnet, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([CustomJsonUtils.getCustomJsonOperation(json, username, keyType, mainnet)], key, false, options);
});
const getCustomJsonOperation = (json, username, keyType, mainnet) => {
    return [
        'custom_json',
        {
            id: mainnet ? mainnet : Config.steemEngine.mainnet,
            json: typeof json === 'string' ? json : JSON.stringify(json),
            required_auths: keyType === KeyType.ACTIVE ? [username] : [],
            required_posting_auths: keyType === KeyType.POSTING ? [username] : [],
        },
    ];
};
const getCustomJsonTransaction = (json, username, keyType, mainnet) => {
    return SteemTxUtils.createTransaction([
        CustomJsonUtils.getCustomJsonOperation(json, username, keyType, mainnet),
    ]);
};
export const CustomJsonUtils = {
    send,
    getCustomJsonOperation,
    getCustomJsonTransaction,
};
